const scope = "trackingError";
export default scope;